export default function ShadowDOMDemoNoSnap() {
  return (
    <iframe
      title="codesandbox"
      src="https://codesandbox.io/embed/6vcl2f?view=Editor+%2B+Preview&module=%2Findex.tsx"
      style={{
        width: '100%',
        height: 350,
        border: 0,
      }}
      sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
    />
  );
}
